import { convertObjectToParams, DATE_FORMAT_V2_FULL } from "@/utils";
import moment from "moment";
import { FINANCIAL_LIST, MOST_RECENT_TIME_SHEET_APPROVED } from "../mutation-types";
import http from "./helpers/httpInterceptor";

const state = () => ({
  mostRecentTimeSheetApproved: {},
  financialYearList: [],
});

// mutations
const mutations = {
  [MOST_RECENT_TIME_SHEET_APPROVED](state, data) {
    state.mostRecentTimeSheetApproved = moment(data).format(DATE_FORMAT_V2_FULL);
  },
  [FINANCIAL_LIST](state, data) {
    state.financialYearList = data;
  },
};

// actions
const actions = {
  getMostRecentTimeSheetApproved({ commit }, payload) {
    return http
      .get(`/tms/advance/most-recent-timesheet-approved${convertObjectToParams(payload)}`)
      .then((res) => {
        const { toDate } = res.data.data;
        commit(MOST_RECENT_TIME_SHEET_APPROVED, toDate);
        return res.data;
      })
      .catch((error) => {
        throw error;
      });
  },
  getFinancialYear({ commit }) {
    return http
      .get(`/tms/advance/get-before-financial-year`)
      .then((res) => {
        commit(FINANCIAL_LIST, res.data.data ? [res.data.data] : []);
        return res.data;
      })
      .catch((error) => {
        commit(FINANCIAL_LIST, []);
        throw error;
      });
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
